import React, { useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form } from "formik";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { useParams } from "react-router";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { nhmApplicants } from "../../../SchemaInfo/info";
import { nhmApplicantsSchema } from "../../../Schemas/NHM Applicants/nhm_applicants_schema";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useNavigate } from "react-router";

const EditApplicants = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [farmerInfo, setFarmerInfo] = useState(nhmApplicants);
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/nhm-applicants/getNHMApplicantsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFarmerInfo(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values, actions) => {
    values = { ...values, type: "" };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest(
      "PATCH",
      `/nhm-applicants/updateNHMApplicantsByID/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Application Edit successfully!");
          navigate(`/view-nhm-applicants/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          {/* HEADER */}
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                {/* <h1 className="page-title mb-1 justify-content-center fs-1 p-2">
                  👨‍🌾 शेडनेट हाऊस योजना पात्रता तपासणी
                </h1> */}
                <h1 className="page-title mb-1 justify-content-center fs-1 p-2">
                  👨‍🌾 {data?.Structure} Schema Eligibility
                </h1>
                {/* <h4 className="text-muted">
                  <StepRoutes />
                </h4> */}
              </div>
              <hr></hr>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {" "}
              {/* FORM FOR ELIGIBILITY CHECK */}
              <div>
                <div className="card my-5">
                  <div className="card-header bg-primary-lt p-3">
                    <h2 className="page-title ">Edit Farmer Info</h2>
                  </div>
                  <Formik
                    initialValues={farmerInfo}
                    validationSchema={nhmApplicantsSchema}
                    onSubmit={handelSubmit}
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body mt-2">
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Name :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Name" type="text" />
                              {props.touched.Name && props.errors.Name && (
                                <p className="text-danger">
                                  {props.errors.Name}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Contact Number :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Mobile" type="text" />
                              {props.touched.Mobile && props.errors.Mobile && (
                                <p className="text-danger">
                                  {props.errors.Mobile}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Alternate Contact Number :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="alterContactNo"
                                type="text"
                                placeholder="Example: 9900886677"
                              />
                              {props.touched.alterContactNo &&
                                props.errors.alterContactNo && (
                                  <p className="text-danger">
                                    {props.errors.alterContactNo}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Village :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Village" type="text" />
                              {props.touched.Village &&
                                props.errors.Village && (
                                  <p className="text-danger">
                                    {props.errors.Village}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Taluka :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Taluka" type="text" />
                              {props.touched.Taluka && props.errors.Taluka && (
                                <p className="text-danger">
                                  {props.errors.Taluka}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              District :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="District" type="text" />
                              {props.touched.District &&
                                props.errors.District && (
                                  <p className="text-danger">
                                    {props.errors.District}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Structure :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Structure" type="text" />
                              {props.touched.Structure &&
                                props.errors.Structure && (
                                  <p className="text-danger">
                                    {props.errors.Structure}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              System :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="System" type="text" />
                              {props.touched.System && props.errors.System && (
                                <p className="text-danger">
                                  {props.errors.System}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              TubularStructure :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="TubularStructure"
                                type="text"
                              />
                              {props.touched.TubularStructure &&
                                props.errors.TubularStructure && (
                                  <p className="text-danger">
                                    {props.errors.TubularStructure}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Size :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="size" type="text" />
                              {props.touched.size && props.errors.size && (
                                <p className="text-danger">
                                  {props.errors.size}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Area :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="Area" type="text" />
                              {props.touched.Area && props.errors.Area && (
                                <p className="text-danger">
                                  {props.errors.Area}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Area SqM :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="areaSqM" type="text" />
                              {props.touched.areaSqM &&
                                props.errors.areaSqM && (
                                  <p className="text-danger">
                                    {props.errors.areaSqM}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Subsidy Percent :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="subsidyPercent" type="text" />
                              {props.touched.subsidyPercent &&
                                props.errors.subsidyPercent && (
                                  <p className="text-danger">
                                    {props.errors.subsidyPercent}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Max Subsidy(Rs) :
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="maxSubsidyRs" type="text" />
                              {props.touched.maxSubsidyRs &&
                                props.errors.maxSubsidyRs && (
                                  <p className="text-danger">
                                    {props.errors.maxSubsidyRs}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Tentative Start Date :
                            </label>
                            <div className="w-100 col">
                              <CustomSelect type="text" name="tenDate">
                                <option value="">Select</option>
                                <option value="Next 15 days">
                                  Next 15 days
                                </option>
                                <option value="Next 1 -2 month">
                                  Next 1 - 2 months
                                </option>
                                <option value="Next 3-4 months">
                                  Next 3 - 4 months
                                </option>
                              </CustomSelect>

                              {props.touched.tenDate &&
                                props.errors.tenDate && (
                                  <p className="text-danger">
                                    {props.errors.tenDate}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Are you looking for a bank loan? :
                            </label>
                            <div className="col-9">
                              <div className="d-flex gap-3">
                                <CustomRadioButton
                                  type="radio"
                                  name="bankLoan"
                                  value="yes"
                                />
                                <label>Yes</label>
                                <CustomRadioButton
                                  type="radio"
                                  name="bankLoan"
                                  value="no"
                                />
                                <label>No</label>
                              </div>
                              {props.touched.bankLoan &&
                                props.errors.bankLoan && (
                                  <p className="text-danger">
                                    {props.errors.bankLoan}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Applicant 7/12 Document :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="satbaraDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "satbaraDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.satbaraDoc &&
                                props.errors.satbaraDoc && (
                                  <p className="text-danger">
                                    {props.errors.satbaraDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Applicant 8A Extract :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="utaraDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "utaraDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.utaraDoc &&
                                props.errors.utaraDoc && (
                                  <p className="text-danger">
                                    {props.errors.utaraDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Caste/Tribe Certificate (if applicable) :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="castDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "castDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.castDoc &&
                                props.errors.castDoc && (
                                  <p className="text-danger">
                                    {props.errors.castDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Disability Certificate (if applicable) :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="certiDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "certiDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.certiDoc &&
                                props.errors.certiDoc && (
                                  <p className="text-danger">
                                    {props.errors.certiDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              Shade Net House Training Certificate :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="studyDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "studyDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.studyDoc &&
                                props.errors.studyDoc && (
                                  <p className="text-danger">
                                    {props.errors.studyDoc}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="Submit" />

                            <SimpleButton
                              buttonText="Cancel"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditApplicants;
